













































































































import Vue from "vue";
import * as moment from "moment";
import $store from "@/store/store";
import Component, { mixins } from "vue-class-component";
import { Rapport } from "@/shared/Rapport";
import MobileMixin from "@/mixins/mobileMixin";
import PdfViewer from "@/components/pdf-viewer.vue";
import GraphiqueInfos from "@/homeGraph/graphique_infos.vue";
import GraphTop3 from "@/homeGraph/graph_top3.vue";
import VueApexCharts from "vue-apexcharts";
import GraphDonut from "@/homeGraph/graph_donut.vue";

Vue.component("apexchart", VueApexCharts);

@Component({
  components: {
    GraphiqueInfos,
    GraphTop3,
    GraphDonut,
  },
})
export default class Graph extends mixins(MobileMixin) {
  public donutOptions = {
    labels: ["UberEats", "Deliveroo", "Serie 3", "Serie 4", "Serie 5"],
  };
  public chartOptions = {
    chart: { height: 350, type: "radialBar", toolbar: { show: false } },
    plotOptions: {
      radialBar: {
        size: 360,
        startAngle: -135,
        endAngle: 225,
        hollow: {
          margin: 0,
          size: "70%",
          background: "#fff",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24,
          },
        },
        track: {
          background: "#fff",
          strokeWidth: "67%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35,
          },
        },
        dataLabels: {
          show: true,
          name: { offsetY: -10, show: true, color: "#888", fontSize: "17px" },
          value: {
            formatter: (val: any) => {
              return parseInt(val);
            },
            color: "#111",
            fontSize: "36px",
            show: true,
          },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ["#ABE5A1"],
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    stroke: { lineCap: "round" },
    labels: ["%"],
  };
  public series = [44, 55, 13, 43, 22];
  public series2 = [(265 * 100) / 300];
  public itemsCA = [
    { KEY: "CA HT", VALUE: 1234.55, DAY: "HIER", DAY_VALUE: 1010.35 },
    { KEY: "CA HT", VALUE: 1234.55, DAY: "JEUDI DERNIER", DAY_VALUE: 1325.0 },
    {
      KEY: "CA HT",
      VALUE: 1234.55,
      DAY: "JEUDI 26/11/2020",
      DAY_VALUE: 1500.0,
    },
    { KEY: "CA HT", VALUE: 1234.55, DAY: "JEUDI 26/12/2021", DAY_VALUE: 950.0 },
  ];
  public itemsCouverts = [
    { KEY: "Couverts", VALUE: 60, DAY: "HIER", DAY_VALUE: 50 },
    { KEY: "Couverts", VALUE: 60, DAY: "JEUDI DERNIER", DAY_VALUE: 65 },
    { KEY: "Couverts", VALUE: 60, DAY: "JEUDI 26/11/2020", DAY_VALUE: 75 },
    { KEY: "Couverts", VALUE: 60, DAY: "JEUDI 26/12/2019", DAY_VALUE: 45 },
  ];
  public itemsTop3Ventes = {
    NOM1: "Formule BBQ Ribs",
    VALUE1: 2329.02,
    IMG1: "/img/Top1_.png",
    INI1: "",
    NOM2: "Formule BBQ Burger",
    VALUE2: 1115.13,
    IMG2: "/img/Top2_w.png",
    INI2: "",
    NOM3: "Côte de boeuf",
    VALUE3: 824.09,
    IMG3: "/img/Top3_s.png",
    INI3: "",
  };
  public itemsTop3Vendeurs = {
    NOM1: "Samy Delaunay",
    VALUE1: 543.21,
    INI1: "SD",
    IMG1: "",
    NOM2: "Reynald Crochetet",
    VALUE2: 432.1,
    INI2: "RC",
    IMG2: "",
    NOM3: "Thomas Marguerin",
    VALUE3: 321.09,
    INI3: "TM",
    IMG3: "",
  };
  public comboboxItems = [
    "Chiffre d'affaire",
    "Couverts",
    "TOP 3 des Ventes",
    "TOP 3 des Vendeurs",
    "Repartition CA",
    "Objectif",
  ];
  public graphsSelected = [];
  public devise = "€";

  public mounted() {
    // pass
  }
}
